import { render, staticRenderFns } from "./hpa-scaling-rule.vue?vue&type=template&id=65ce68d4&"
import script from "./hpa-scaling-rule.vue?vue&type=script&lang=js&"
export * from "./hpa-scaling-rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports